<div class="bk-panel sxt">
  <data-table [seamless]="true" [loading]="loading" [maxHeight]="'420px'" [skeletonColumns]="3" [skeletonRows]="5">
    @if (rows.length) {
      <table class="bk-log">
        <thead>
          <tr>
            <th scope="col" class="sxt__name">Segment</th>
            <th scope="col" class="sxt__created">Created</th>
            <th scope="col" class="sxt__action"><span class="bk-sr-only">Action</span></th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.key) {
            <tr>
              <td class="sxt__name">
                <span class="bk-msg">
                  <span class="bk-msg__subject">{{ row.name }}</span>
                  <span class="bk-msg__preview" [attr.title]="row.rule || null">{{ row.rule || 'No conditions' }}</span>
                </span>
              </td>
              <td class="quiet sxt__created">{{ row.created }}</td>
              <td class="sxt__action">
                <button
                  type="button"
                  class="bk-btn bk-btn--ghost sxt__use"
                  [attr.aria-label]="'Use conditions from ' + row.name"
                  (click)="handleUseExistingRule(row.segment)"
                >
                  Use conditions
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <app-empty-state icon="segments" message="No segments to copy from yet" [query]="searchTerm" size="small" />
    }
  </data-table>
</div>
